/* eslint-disable max-len */
import * as yup from 'yup';

const ERROS = {
  CAMPOS_OBRIGATORIOS: 'O campo é obrigatório',
  NUMERO_INVALIDO: 'Deve ser um número válido',
  DATA_INVALIDA: 'Data inválida',
  PORCENTAGEM_INVALIDA: 'Deve ser informada uma porcentagem entre 0 e 100',
  VALOR_MONETARIO_INVALIDO: 'Valor monetário inválido',
  SELECAO_OBRIGATORIA: 'É necessário selecionar uma opção',
}

export const step2ValidationSchema = yup.object({
  fundo_municipal_agricultura_familiar: yup.boolean()
    .nullable()
    .test('required-selection', ERROS.SELECAO_OBRIGATORIA, function (value) {
      return value === true || value === false;
    }),

  tipo_publicacao: yup.string()
    .nullable()
    .when('fundo_municipal_agricultura_familiar', {
      is: true,
      then: (schema) => schema.required(ERROS.CAMPOS_OBRIGATORIOS),
      otherwise: (schema) => schema.notRequired(),
    }),

  nro_publicacao: yup.string()
    .nullable()
    .when('fundo_municipal_agricultura_familiar', {
      is: true,
      then: (schema) => schema.required(ERROS.CAMPOS_OBRIGATORIOS),
      otherwise: (schema) => schema.notRequired(),
    }),

  data_publicacao: yup.string()
    .nullable()
    .when('fundo_municipal_agricultura_familiar', {
      is: true,
      then: (schema) => schema.required(ERROS.CAMPOS_OBRIGATORIOS),
      otherwise: (schema) => schema.notRequired(),
    }),
})
